import { IProductDefinitionList, NodeObjectRepository } from '@/models/assembly';

export const GordionKesonlu = {
  'gordion-kesonlu': {
    steps: [
      {
        order: 1,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {
          const ayak = repository.get('gordion_ayak_arc29_yyy')
            .show()
            .rotate([Math.PI, 1, 0, 0], 1, 'easeOutElastic');

          const kece = repository.get('gordion_kece_yyy')
            .show()
            .rotate([Math.PI, 1, 0, 0], 1, 'easeOutElastic');

          repository.track(ayak, kece);
        },
      },
      {
        order: 2,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const ayak = repository.get('gordion_ayak_arc29_yyy')
            .resetRotation([1, 0, 0]);

          const kece = repository.get('gordion_kece_yyy')
            .resetRotation([1, 0, 0]);

          const vida = repository.get('m6x_22_yhb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 10,
              };
            });

          const travers = repository.get('gordiontravers_arc_yyy')
            .show();


          vida.show();
          vida.resetPosition(1.5);

          repository.track(ayak, kece, vida, travers);
        },
      },
      {
        order: 3,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const vida = repository.get('m6x_25_ysb_civata_siyah_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 10,
              };
            })
            .show()
            .resetPosition(1.5);

          repository.track(vida);
        },
      },
      {
        order: 4,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const kapak = repository.get('keson_kapak_yyy')
            .hide();


          const keson = repository.get('keson_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const pul = repository.get('pulsiyah_5_6_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const cinko = repository.get('m6x_50_ysb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');



          keson.show();
          pul.show();
          cinko.show();

          keson.resetPosition(1, 'easeOutQuad');
          pul.resetPosition(1, 'easeOutQuad');
          cinko.resetPosition(1, 'easeOutQuad');
          kapak.show();

          repository.track(keson, pul, cinko, kapak);
        },
      },
      {
        order: 5,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const dik = repository.get('m6_dikdortgen_somn_cnk_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 50,
              };
            }, .001, 'easeOutQuad')
            .show()
            .resetPosition(1, 'easeOutQuad');

          repository.track(dik);
        },
      },
      {
        order: 6,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tas = repository.get('gordion_alm_tasiyicikol_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const vida = repository.get('m6x_25_rysb_civatakafa2_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x - 50,
              };
            }, .001, 'easeOutQuad');

          const vida2 = repository.get('m6x_25_rysb_civatakafa_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x + 50,
              };
            }, .001, 'easeOutQuad');

          tas.show();
          vida.show();
          vida2.show();

          tas.resetPosition(1, 'easeOutQuad');
          vida.resetPosition(1, 'easeOutQuad');
          vida2.resetPosition(1, 'easeOutQuad');

          repository.track(tas, vida, vida2);
        },
      },
      {
        order: 7,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const camT = repository.get('gordion_camtutalm_ikili_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const vida = repository.get('m6x_12_ysb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const tam = repository.get('genesis_aratampon_syh_cnk_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          camT.show();
          vida.show();
          tam.show();

          camT.resetPosition(1, 'easeOutQuad');
          vida.resetPosition(1, 'easeOutQuad');
          tam.resetPosition(1, 'easeOutQuad');

          repository.track(camT, vida, tam);
        },
      },
      {
        order: 8,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const traversKapak = repository.get('gordion_travers_yankapak_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 50,
              };
            }, .001, 'easeOutQuad');

          const vida = repository.get('m6x_10_setskur_civata_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x + 50,
              };
            }, .001, 'easeOutQuad');

          const vida3 = repository.get('m6x_10_setskur_civata2_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x - 50,
              };
            }, .001, 'easeOutQuad');


          traversKapak.show();
          vida.show();
          vida3.show();

          traversKapak.resetPosition(1, 'easeOutQuad');
          vida.resetPosition(1, 'easeOutQuad');
          vida3.resetPosition(1, 'easeOutQuad');

          repository.track(traversKapak, vida, vida3);
        },
      },
      {
        order: 9,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_comp_tap_80x100_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const civata = repository.get('m6x_25_ysb_civata_siyah2_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const civataCinko = repository.get('m6x_22_yhb_civata_cinko1_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');


          tab.show();
          civata.show();
          civataCinko.show();

          tab.resetPosition(1, 'easeOutQuad');
          civata.resetPosition(1, 'easeOutQuad');
          civataCinko.resetPosition(1, 'easeOutQuad');

          repository.track(tab, civata, civataCinko);
        },
      },
      {
        order: 10,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_flansli_cam_80x_100_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const civata = repository.get('m6x_12_ysb_civata_cinko2_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const civataCinko = repository.get('m6x_12_yhb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');


          tab.show();
          civata.show();
          civataCinko.show();

          tab.resetPosition(1, 'easeOutQuad');
          civata.resetPosition(1, 'easeOutQuad');
          civataCinko.resetPosition(1, 'easeOutQuad');

          repository.track(tab, civata, civataCinko);
        },
      },
      {
        order: 11,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_onpaneltutucu_arc29_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const civata = repository.get('m6x_15_ysb_civata_siyah_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');


          tab.show();
          civata.show();

          tab.resetPosition(1, 'easeOutQuad');
          civata.resetPosition(1, 'easeOutQuad');

          repository.track(tab, civata);
        },
      },
      {
        order: 12,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_onpaneltutucu2_arc29_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const civata = repository.get('m6x_12_yhb_civata_cinko2_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x + 50,
              };
            }, .001, 'easeOutQuad');


          tab.show();
          civata.show();

          tab.resetPosition(1, 'easeOutQuad');
          civata.resetPosition(1, 'easeOutQuad');

          repository.track(tab, civata);
        },
      },
      {
        order: 13,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('priz_sis_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad').show()
            .resetPosition(1, 'easeOutQuad');

          repository.track(tab);
        },
      },
      {
        order: 14,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_masa_kablokapak_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad')
            .show()
            .resetPosition(1, 'easeOutQuad');

          repository.track(tab);
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/defs/gordion-kesonlu.ts